export default {
    common: {
        appName: 'Swift Invoice',
        cancel: 'Abbrechen',
        email: 'E-Mail',
        password: 'Passwort',
        or: 'oder',
        change: 'Ändern',
        delete: 'Löschen',
        save: 'Speichern',
        edit: 'Bearbeiten',
        add: 'Hinzufügen',
        close: 'Schließen',
        date: 'Datum',
        total: 'Gesamt',
        status: 'Status',
        amount: 'Betrag',
        quantity: 'Menge',
        rate: 'Satz',
        tax: 'Steuer',
        discount: 'Rabatt',
        note: 'Notiz',
        notes: 'Notizen',
        description: 'Beschreibung',
        client: 'Kunde',
        item: 'Artikel',
        items: 'Artikel',
        type: 'Typ',
        category: 'Kategorie',
        phone: 'Telefon',
        name: 'Name',
        subject: 'Betreff',
        saveAndClose: 'Speichern und Schließen',
        saveAndSendEmail: 'Speichern und E-Mail senden',
        sendEmail: 'E-Mail senden',
        send: 'Senden',
        print: 'Drucken',
        moreActions: 'Weitere Aktionen',
        preparingPdf: 'PDF wird vorbereitet...',
        pdfPreparationFailed: 'PDF konnte nicht vorbereitet werden',
        warning: 'Warnung',
        ok: 'OK',
        uploadSuccess: 'Upload erfolgreich',
        saveSuccess: 'Speichern erfolgreich',
        deleteSuccess: 'Löschen erfolgreich',
        deleteFailed: 'Löschen fehlgeschlagen',
        saveFailed: 'Speichern fehlgeschlagen',
        loadFailed: 'Laden fehlgeschlagen',
        systemError: 'Systemfehler',
        sendSuccess: 'Senden erfolgreich',
        updateSuccess: 'Aktualisierung erfolgreich',
        unsavedChangesMsg: 'Sie haben ungespeicherte Änderungen. Möchten Sie diese speichern oder verwerfen?',
        saveChangesTitle: 'Änderungen speichern?',
        confirmSave: 'Speichern',
        discard: 'Verwerfen',
        validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        deleteFailedMsg: 'Löschen fehlgeschlagen',
        shipping: 'Versand',
        attachment: 'Anhang',
        days: 'Tage',
        excl: '(exkl.)',
        incl: '(inkl.)',
        of: 'von'
    },
    login: {
        heroPrefix: 'Intelligente ',
        heroInvoicing: 'Rechnungsstellung',
        heroMiddle: ',',
        heroSimplified: 'Vereinfacht',
        heroSuffix: ' für Sie.',
        subtitle1: 'Erstellen, senden und verwalten Sie Rechnungen mühelos.',
        subtitle2: 'Werden Sie mit Swift Invoice schneller bezahlt.',
        feature1Title: 'Professionelle Rechnungen',
        feature1Text: 'Erstellen Sie in wenigen Minuten schöne Rechnungen',
        feature2Title: 'Echtzeit-Verfolgung',
        feature2Text: 'Verfolgen Sie Zahlungen und Rechnungsstatus',
        feature3Title: 'Sicher & Zuverlässig',
        feature3Text: 'Ihre Daten sind mit Enterprise-Sicherheit geschützt',
        welcomeBack: 'Willkommen zurück',
        signInToContinue: 'Melden Sie sich bei Ihrem Konto an, um fortzufahren',
        enterEmail: 'Geben Sie Ihre E-Mail ein',
        enterPassword: 'Geben Sie Ihr Passwort ein',
        rememberMe: 'Angemeldet bleiben',
        forgotPassword: 'Passwort vergessen?',
        signIn: 'Anmelden',
        signingIn: 'Anmeldung…',
        continueWithGoogle: 'Mit Google fortfahren',
        continueWithApple: 'Mit Apple fortfahren',
        createAccount: 'Konto erstellen',
        startUsing: 'Swift Invoice verwenden',
        companyName: 'Firmenname',
        enterCompanyName: 'Geben Sie Ihren Firmennamen ein',
        alreadyHaveAccount: 'Bereits ein Konto? Anmelden',
        footerRights: '© 2026 Swift Invoice. Alle Rechte vorbehalten.',
        termsOfService: 'Nutzungsbedingungen',
        contactUs: 'Kontakt: goodinvoicego@gmail.com',
        betaDialogBody: 'Unser Team hat die erste Version des Webs abgeschlossen <br> Diese Version ist nur für iPhone-Benutzer verfügbar <br> Wir werden die Web-Funktion so schnell wie möglich verbessern und für alle öffnen <br>',
        ieDialogBody: 'Leider unterstützen wir den IE-Browser aufgrund von Kompatibilitätsproblemen derzeit nicht. Wenn Sie ihn verwenden möchten, laden Sie bitte',
        resetPasswordTitle: 'Passwort zurücksetzen',
        sendResetEmail: 'Reset-E-Mail senden',
        resetEmailSent: 'E-Mail zum Zurücksetzen des Passworts gesendet. Bitte überprüfen Sie Ihren Posteingang.',
        bindingTitle: 'Bestehendes Konto verknüpfen',
        bindingHintPrefix: 'Für die E-Mail-Adresse existiert bereits ein Konto ',
        bindingHintSuffix: ". Geben Sie das Passwort dieses Kontos ein, um Ihre Google-Anmeldung zu verknüpfen.",
        enterAccountPassword: 'Kontopasswort eingeben',
        linkAccount: 'Konto verknüpfen',
        validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        validPassword: 'Passwort muss mindestens 6 Zeichen lang sein',
        validCompanyName: 'Bitte füllen Sie Ihren Firmennamen aus'
    },
    account: {
        title: 'Konto',
        profile: 'Profil',
        swiftAccount: 'Swift Invoice-Konto',
        connectSocial: 'Soziale Konten verbinden',
        companyLogo: 'Firmenlogo',
        addLogo: 'Logo hinzufügen',
        uploading: 'wird hochgeladen...',
        currentPlan: 'Aktueller Plan: Swift {plan}',
        planActiveUntil: 'Plan aktiv bis {date}',
        sharedWithMobile: 'Mit mobiler App geteilt',
        subscriptionExpired: 'Ihr Abonnement ist abgelaufen',
        planNote: 'Melden Sie sich erneut an, wenn Ihr Abonnement-Status nicht aktualisiert wurde.',
        upgradeToPro: 'Auf Swift Pro upgraden',
        viewPlans: 'Abonnement-Pläne ansehen',
        connecting: 'Verbindung wird hergestellt…',
        connectGoogle: 'Google verbinden',
        googleConnected: 'Google verbunden',
        googleConnectedWithEmail: 'Google verbunden ({email})',
        connectApple: 'Apple verbinden',
        appleConnected: 'Apple verbunden',
        appleConnectedWithEmail: 'Apple verbunden ({email})',
        logoUuidMissing: 'UUID des Firmenlogos fehlt',
        googleConnectedToast: 'Google-Konto verbunden.',
        appleConnectedToast: 'Apple-Konto verbunden.'
    },
    menu: {
        invoices: 'Rechnungen',
        estimates: 'Kostenvoranschläge',
        purchaseOrders: 'Bestellungen',
        items: 'Artikel',
        clients: 'Kunden',
        expenses: 'Ausgaben',
        reports: 'Berichte',
        settings: 'Einstellungen',
        companyInfo: 'Firmeninfo',
        taxes: 'Steuern',
        default: 'Standard',
        customizeInvoice: 'Rechnung anpassen',
        sendFeedback: 'Feedback senden',
        newReply: '1 neue Antwort',
        signOut: 'Abmelden',
        signOutConfirm: 'Möchten Sie sich wirklich abmelden?',
        addBusiness: 'Unternehmen hinzufügen',
        newBusinessTitle: 'Neues Unternehmen',
        businessName: 'Unternehmensname',
        businessNamePlaceholder: 'Unternehmensname eingeben',
        createBusiness: 'Erstellen',
        businessNameRequired: 'Unternehmensname eingeben',
        createBusinessSuccess: 'Unternehmen erstellt'
    },
    network: {
        loginExpired: 'Anmeldung abgelaufen, bitte melden Sie sich erneut an',
        requestTimeout: 'Zeitüberschreitung der Anfrage, bitte überprüfen Sie das Netzwerk'
    },
    language: {
        label: 'Sprache',
        zh: '中文',
        en: 'English'
    },
    invoice: {
        searchPlaceholder: 'Rechnungen durchsuchen',
        addInvoice: 'Rechnung hinzufügen',
        overdueInvoices: 'Überfällige Rechnungen',
        paidInvoices: 'Bezahlte Rechnungen',
        unpaidInvoices: 'Unbezahlte Rechnungen',
        unsentInvoices: 'Nicht gesendete Rechnungen',
        columnNumber: 'Nummer',
        columnClient: 'Kunde',
        columnStatus: 'Status',
        statusFullyPaid: 'Vollständig bezahlt',
        statusPartial: 'Teilweise',
        statusOverdue: 'Überfällig',
        statusUnsent: 'Nicht gesendet',
        statusSent: 'Gesendet',
        statusOpened: 'Geöffnet',
        actionRecordPayment: 'Zahlung erfassen',
        actionMarkAsSent: 'Als gesendet markieren',
        actionCopy: 'Kopieren',
        actionDelete: 'Löschen',
        copyDialogTitle: 'Rechnung kopieren',
        copyTargetType: 'Kopieren nach',
        copyOptions: 'Kopieroptionen',
        copyClient: 'Klient kopieren',
        copyItems: 'Artikel kopieren',
        copyAttachments: 'Anhänge kopieren',
        confirmDelete: 'Dies löscht die Rechnung. Fortfahren?',
        copySuccess: 'Rechnung kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        deleteSuccess: 'Rechnung gelöscht',
        deleteFailed: 'Löschen fehlgeschlagen',
        recordPaymentDialogTitle: 'Zahlung erfassen',
        markAsFullyPaid: 'Als vollständig bezahlt markieren',
        formAmount: 'Betrag',
        formDate: 'Datum',
        formPaymentMethod: 'Zahlungsmethode',
        formNote: 'Notiz',
        allYears: 'Alle Jahre',
        errorMorePaymentThanBalanceDue: 'Mehr Zahlung als offener Betrag',
        errorAmountMustBeGreaterThanZero: 'Der Betrag muss größer als null sein',
        dueDateToday: 'Heute',
        dueDateDaysAgo: '{days} Tage her',
        dueDateInDays: 'in {days} Tagen'
    },
    estimate: {
        pageTitlePurchaseOrders: 'Bestellungen',
        pageTitleEstimates: 'Kostenvoranschläge',
        searchPlaceholderPurchaseOrders: 'Bestellungen durchsuchen',
        searchPlaceholderEstimates: 'Kostenvoranschläge durchsuchen',
        addPurchaseOrder: 'Bestellung hinzufügen',
        addEstimate: 'Kostenvoranschlag hinzufügen',
        columnNumber: 'Nummer',
        columnClient: 'Kunde',
        columnDate: 'Datum',
        columnEmail: 'E-Mail',
        columnStatus: 'Status',
        columnTotal: 'Gesamt',
        statusUnsent: 'Nicht gesendet',
        statusSent: 'Gesendet',
        actionMarkAsSent: 'Als gesendet markieren',
        actionCopy: 'Kopieren',
        actionDelete: 'Löschen',
        actionConvertToInvoice: 'In Rechnung umwandeln',
        copyDialogTitle: '{document} kopieren',
        copyTargetType: 'Kopieren nach',
        copyOptions: 'Kopieroptionen',
        copyClient: 'Klient kopieren',
        copyItems: 'Artikel kopieren',
        copyAttachments: 'Anhänge kopieren',
        confirmDelete: 'Dies löscht {document}. Fortfahren?',
        convertConfirm: 'Dieses {document} in eine Rechnung umwandeln? Das Datum wird auf heute gesetzt.',
        copySuccess: '{document} kopiert',
        copyFailed: 'Kopieren fehlgeschlagen',
        convertSuccess: '{document} in Rechnung umgewandelt',
        convertFailed: 'Umwandlung fehlgeschlagen',
        deleteSuccess: '{document} gelöscht',
        deleteFailed: 'Löschen fehlgeschlagen',
        dueDateToday: 'Heute',
        dueDateDaysAgo: '{days} Tage her',
        dueDateInDays: 'in {days} Tagen'
    },
    item: {
        pageTitle: 'Artikel',
        searchPlaceholder: 'Artikel durchsuchen',
        addItem: 'Artikel hinzufügen',
        columnInventoryCountUnit: 'Lagerbestand/Einheit'
    },
    client: {
        pageTitle: 'Kunden',
        searchPlaceholder: 'Kunden durchsuchen',
        addClient: 'Kunden hinzufügen',
        columnClientName: 'Kundenname',
        columnEmail: 'E-Mail',
        columnPhone: 'Telefon',
        columnBalanceDue: 'Offener Betrag',
        noNameFallback: 'KEIN NAME'
    },
    expense: {
        pageTitle: 'Ausgaben',
        searchPlaceholder: 'Ausgaben durchsuchen',
        addExpense: 'Ausgabe hinzufügen',
        columnDescription: 'Beschreibung',
        columnDate: 'Datum',
        columnTotal: 'Gesamt'
    },
    report: {
        headerTitle: 'Berichte',
        tabDashboard: 'Dashboard',
        tabReportList: 'Berichtsliste',
        export: 'Exportieren',
        annualSalesByClient: 'Jährliche Verkäufe nach Kunde',
        totalOutstandingBalance: 'Gesamter offener Betrag',
        invoicesCountSuffix: 'Rechnungen',
        byMonth: 'Nach Monat',
        byQuarter: 'Nach Quartal',
        noSalesFound: 'Keine Verkäufe gefunden',
        filterReportTypes: 'Berichtstypen',
        filterTimePeriod: 'Zeitraum',
        filterView: 'Ansicht',
        optionMonthly: 'Monatlich',
        optionQuarterly: 'Quartalsweise',
        customerAgingTitle: 'Forderungsalter',
        noDataForDateRange: 'Keine Daten für diesen Zeitraum',
        typeSalesByDate: 'Verkäufe nach Datum',
        typeSalesByClient: 'Verkäufe nach Kunde',
        typeSalesByItem: 'Verkäufe nach Artikel',
        typeSalesJournal: 'Verkaufsjournal',
        typePaymentsByDate: 'Zahlungen nach Datum',
        typePaymentsByClient: 'Zahlungen nach Kunde',
        typePaymentsByType: 'Zahlungen nach Typ',
        typePaymentsJournal: 'Zahlungsjournal',
        typeExpenseByCategory: 'Ausgaben nach Kategorie',
        typeExpenseJournal: 'Ausgabenjournal',
        typeCustomerAging: 'Forderungsalter',
        allYears: 'Alle Jahre',
        allTime: 'Gesamter Zeitraum',
        allSales: 'Alle Verkäufe',
        taxYearSales: 'Verkäufe Steuerjahr {year}',
        firstColumnMonth: 'Monat',
        firstColumnQuarter: 'Quartal',
        columnSubTotal: 'Zwischensumme',
        columnTax: 'Steuer',
        columnDiscount: 'Rabatt',
        columnTotal: 'Gesamt',
        columnAmountPaid: 'Bezahlter Betrag',
        columnAmountOwed: 'Geschuldeter Betrag',
        columnClient: 'Kunde',
        columnItem: 'Artikel',
        columnUnitType: 'Einheitentyp',
        columnQuantity: 'Menge',
        columnRateAvg: 'Satz (Ø)',
        columnInvoiceDate: 'Rechnungsdatum',
        columnInvoiceNo: 'Rechnungs-Nr.',
        columnType: 'Typ',
        columnPaymentDate: 'Zahlungsdatum',
        columnCategory: 'Kategorie',
        columnExpenseDate: 'Ausgabedatum',
        columnMerchant: 'Händler',
        columnDescription: 'Beschreibung',
        columnCurrentDue: 'Aktuell offen',
        column1To30DaysOverdue: '1-30 Tage überfällig',
        column31To60DaysOverdue: '31-60 Tage überfällig',
        column61To90DaysOverdue: '61-90 Tage überfällig',
        column91PlusDaysOverdue: '91+ Tage überfällig',
        monthNames: 'Jan, Feb, Mär, Apr, Mai, Jun, Jul, Aug, Sep, Okt, Nov, Dez',
        totalRowLabel: 'Gesamt'
    },
    invoiceCreate: {
        pageTitlePrefix: 'Hinzufügen',
        invoicePrefix: 'Rechnungspräfix',
        tabCreate: 'Erstellen',
        tabPreview: 'Vorschau',
        tabSendEmail: 'E-Mail senden',
        sectionClient: 'Kunde',
        addClient: 'Kunden hinzufügen',
        dialogClientInfo: 'Kundeninformationen',
        basicInformation: 'Grundinformationen',
        labelName: 'Name',
        labelEmail: 'E-Mail',
        labelPhone: 'Telefon',
        billingAddress: 'Rechnungsadresse',
        labelLine1: 'Zeile 1',
        labelLine2: 'Zeile 2',
        labelLine3: 'Zeile 3',
        shippingAddress: 'Lieferadresse',
        labelShippingName: 'Liefername',
        labelNotes: 'Notizen',
        placeholderCreateOrSelect: 'Erstellen oder auswählen...',
        placeholderClientNotes: "Notizen zum Kunden hinzufügen. Diese kann der Kunde nicht sehen",
        sectionItems: 'Artikel',
        saveToYourItem: 'In Ihrem Artikel speichern',
        stock: 'Bestand:',
        placeholderItemCode: 'Artikelcode',
        placeholderQuantity: 'Menge',
        placeholderRate: 'Satz',
        placeholderInputDescription: 'Beschreibung eingeben',
        placeholderInputComment: 'Kommentar eingeben',
        placeholderAddRecipient: 'Empfänger hinzufügen',
        cc: 'Cc',
        bcc: 'Bcc',
        placeholderEmailSubject: 'E-Mail-Betreff',
        placeholderMessage: 'Schreiben Sie Ihre Nachricht...',
        labelTo: 'An',
        labelSubject: 'Betreff',
        sectionAttachments: 'Anhänge',
        sectionComment: 'Kommentar',
        addItem: 'Artikel hinzufügen',
        addPhoto: 'Foto hinzufügen',
        addPayment: 'Zahlung hinzufügen',
        goBack: 'zurück',
        dialogShippingInfo: 'Versandinformationen',
        dialogRecordPayment: 'Zahlung erfassen',
        dialogJobDetails: 'Auftragsdetails',
        labelAmount: 'Betrag',
        labelShipDate: 'Versanddatum',
        labelShipVia: 'Versand über',
        labelTrackingNumber: 'Sendungsverfolgungsnummer',
        labelFob: 'FOB',
        columnDate: 'Datum',
        columnType: 'Typ',
        msgClientEmailError: 'Kunden-E-Mail-Fehler',
        msgAmountGreaterThanZero: 'Der Betrag muss größer als null sein',
        msgMorePaymentThanBalance: 'Mehr Zahlung als offener Betrag',
        mailSentSuccessfully: 'E-Mail erfolgreich gesendet',
        cumulativeTaxNotice: 'Das Web unterstützt die Kumulierung von Steuern in der Rechnung nicht...',
        numberLogicNotice: 'Wir haben kürzlich die Nummernlogik geändert. Wenn Ihre Nummer nicht korrekt ist, bearbeiten Sie sie hier. Sie können auch zu Einstellungen > Rechnung anpassen > Nächste Nummer gehen und den gewünschten Startwert für die Nummerierung festlegen.',
        confirmUnsavedChanges: 'Sie haben ungespeicherte Änderungen. Möchten Sie diese speichern oder verwerfen?',
        pdf: 'PDF',
        taxDiscountWithholding: 'Steuer, Rabatt und Quellensteuer',
        purchaseOrder: 'Bestellung',
        placeholderPurchaseOrderPrefix: 'Bestellungspräfix',
        placeholderEstimatePrefix: 'Kostenvoranschlagspräfix',
        labelStatus: 'Status',
        statusIssued: 'Ausgestellt',
        statusApproved: 'Genehmigt',
        statusPending: 'Ausstehend',
        statusWithdrawn: 'Zurückgezogen',
        tax: 'Steuer'
    },
    createEstimate: {
        pageTitlePrefix: 'Hinzufügen',
        cumulativeTaxNotice: 'Das Web unterstützt die Kumulierung von Steuern im Kostenvoranschlag nicht...'
    },
    updateInvoice: {
        pageTitlePrefix: 'Aktualisieren',
        deletePrefix: 'Löschen',
        confirmDelete: 'Dadurch wird die Rechnung gelöscht. Fortfahren?',
        cumulativeTaxNotice: 'Diese Rechnung enthält kumulierte Steuern. Das Web unterstützt diese Funktion vorerst nicht'
    },
    updateEstimate: {
        pageTitlePrefix: 'Aktualisieren',
        deletePrefix: 'Löschen',
        confirmDelete: 'Dadurch wird {document} gelöscht. Fortfahren?',
        cumulativeTaxNotice: 'Dieser Kostenvoranschlag enthält kumulierte Steuern. Das Web unterstützt diese Funktion vorerst nicht'
    },
    createAccount: {
        title: 'Konto erstellen',
        placeholderEmail: 'E-Mail',
        placeholderPassword: 'Passwort',
        placeholderCompanyName: 'Firmenname',
        createAccountButton: 'Konto erstellen',
        alreadyHaveAccount: 'Bereits ein Konto?',
        signIn: 'Anmelden',
        validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
        validPassword: 'Passwort muss mindestens 6 Zeichen lang sein',
        validCompanyName: 'Bitte füllen Sie Ihren Firmennamen aus'
    },
    clientCreate: {
        pageTitle: 'Kunden hinzufügen',
        basicInformation: 'Grundinformationen',
        labelName: 'Name',
        placeholderName: 'Namen eingeben...',
        labelEmail: 'E-Mail',
        placeholderEmail: 'E-Mail-Adresse eingeben...',
        labelPhone: 'Telefon',
        placeholderPhone: 'Telefonnummer eingeben...',
        billingAddress: 'Rechnungsadresse',
        labelLine1: 'Zeile 1',
        labelLine2: 'Zeile 2',
        labelLine3: 'Zeile 3',
        shippingAddress: 'Lieferadresse',
        sameAsBilling: 'Wie Rechnungsadresse',
        labelShippingName: 'Liefername',
        labelShippingLine1: 'Zeile 1',
        labelShippingLine2: 'Zeile 2',
        labelShippingLine3: 'Zeile 3',
        labelNotes: 'Notizen',
        placeholderNotes: "Notizen zum Kunden hinzufügen. Diese kann der Kunde nicht sehen",
        validEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein'
    },
    clientUpdate: {
        pageTitle: 'Kunden aktualisieren',
        confirmDelete: 'Dadurch wird der Kunde gelöscht. Fortfahren?'
    },
    itemCreate: {
        pageTitle: 'Artikel hinzufügen',
        itemTitle: 'Artikel',
        labelCost: 'Kosten',
        labelUnit: 'Einheit',
        placeholderUnit: 'Einheit',
        defaultTaxes: 'Standardsteuern',
        taxOff: 'aus',
        inventoryTitle: 'Lagerbestand',
        currentInventory: 'Aktueller Lagerbestand',
        adjustInventory: 'Lagerbestand anpassen',
        placeholderQuantity: 'Menge',
        placeholderDateAndTime: 'Datum und Uhrzeit',
        placeholderNote: 'Notiz',
        addButton: 'Hinzufügen',
        columnDate: 'Datum',
        columnQuantity: 'Menge',
        columnNote: 'Notiz',
        withholdingTitle: 'Quellensteuer',
        msgInventoryCannotDisable: 'Lagerbestand kann nach der Aktivierung nicht deaktiviert werden',
        msgDescriptionRequired: 'Die Artikelbeschreibung ist erforderlich',
        msgQuantityRequired: 'Menge ist erforderlich',
        msgDateRequired: 'Datum und Uhrzeit sind erforderlich'
    },
    itemUpdate: {
        pageTitle: 'Artikel bearbeiten',
        columnInvoice: 'Rechnung',
        confirmDelete: 'Dadurch wird der Artikel gelöscht. Fortfahren?'
    },
    createStatement: {
        pageTitle: 'Auszug',
        tabPreview: 'Vorschau',
        tabSendEmail: 'E-Mail senden'
    },
    setting: {
        taxInfo: 'Steuerinfo',
        taxes: 'Steuern',
        taxYearStarts: 'Steuerjahr beginnt',
        taxYearStartSubtitle: 'Legen Sie den ersten Tag des Geschäftsjahres fest',
        rateLabel: 'Satz(%)',
        abbreviation: 'Abkürzung',
        addTax: 'Steuer hinzufügen',
        month: 'Monat',
        day: 'Tag',
        monthPlaceholder: 'Monat',
        dayPlaceholder: 'Tag',
        saveTaxYearStart: 'Speichern',
        deleteDialogTitle: 'Löschen',
        confirmDeleteTax: 'Möchten Sie diese Steuer wirklich löschen?',
        deleteConfirm: 'Löschen',
        taxInfoDialogTitle: 'Steuerinfo',
        taxName: 'Steuername',
        standardRate: 'Standardsteuersatz (%)',
        additionalRate: 'Zusatzsatz',
        deleteRateX: 'X',
        addRate: 'Satz hinzufügen',
        taxType: 'Steuerart',
        exclusive: 'Exklusiv',
        inclusive: 'Inklusiv',
        close: 'schließen',
        saveTax: 'Steuer speichern',
        cantOpenDetailMessage: 'Diese Steuer enthält kumulierte Steuern. Das Web unterstützt diese Funktion vorerst nicht',
        closeButton: 'Schließen',
        rateIsRequired: 'Satz ist erforderlich',
        rateIsRequiredMsg: 'Satz ist erforderlich',
        monthAndDayRequired: 'Monat und Tag sind erforderlich',
        moreRate: ' weiterer Satz',
        moreRates: ' weitere Sätze'
    },
    companyInfo: {
        title: 'Firmeninfo',
        details: 'Details',
        businessName: 'Firmenname',
        businessNamePlaceholder: 'Firmenname',
        name: 'Name',
        phone: 'Telefon',
        email: 'E-Mail',
        businessNumber: 'Geschäftsnummer',
        taxNo: 'Steuer N°',
        deleteField: 'löschen',
        addNewField: 'Neues Feld hinzufügen',
        address: 'Adresse',
        line1: 'Zeile 1',
        line2: 'Zeile 2',
        line3: 'Zeile 3',
        currency: 'Währung',
        currencyLabel: 'Währung',
        symbol: 'Symbol',
        placement: 'Platzierung',
        before: 'Vor',
        after: 'Nach',
        thousandSymbol: 'Tausendertrennzeichen',
        decimalSymbol: 'Dezimaltrennzeichen',
        decimalPlaces: 'Dezimalstellen',
        example: 'Beispiel',
        terms: 'Zahlungsbedingungen',
        termsLabel: 'Zahlungsbedingungen',
        termSameDay: 'Gleicher Tag',
        term7Days: '7 Tage',
        term14Days: '14 Tage',
        term21Days: '21 Tage',
        term30Days: '30 Tage',
        term45Days: '45 Tage',
        term60Days: '60 Tage',
        term90Days: '90 Tage',
        term180Days: '180 Tage',
        term365Days: '365 Tage',
        paymentInfo: 'Zahlungsinformationen',
        displayOnInvoices: 'Auf Rechnungen anzeigen',
        titlePlaceholder: 'Titel',
        jobDetails: 'Auftragsdetails',
        deleteJobDetail: 'löschen',
        addNewJobField: 'neues Feld hinzufügen'
    },
    default: {
        title: 'Standard',
        emailMessage: 'E-Mail-Nachricht',
        enterDescription: 'Beschreibung eingeben',
        emailCc: 'E-Mail-Cc',
        emailBcc: 'E-Mail-Bcc',
        emailTip: 'Gleichzeitig eine E-Mail an die obige Adresse senden.',
        defaultComments: 'Standardkommentare',
        invoice: 'Rechnung',
        estimate: 'Kostenvoranschlag',
        purchaseOrder: 'Bestellung',
        creditMemo: 'Gutschrift',
        emailValidError: 'E-Mail gültig'
    },
    invoiceDesign: {
        template: 'Vorlage',
        color: 'Farbe',
        labels: 'Beschriftungen',
        labelInvoice: 'Rechnung',
        labelEstimate: 'Kostenvoranschlag',
        labelPurchaseOrder: 'Bestellung',
        labelCreditMemo: 'Gutschrift',
        labelReceipt: 'BELEG',
        labelTermsFormat: 'Format der Bedingungen',
        labelBillTo: 'Rechnung an',
        labelFor: 'Für',
        labelDate: 'Datum',
        labelInvoiceNo: 'Rechnungs-Nr.',
        labelEstimateNo: 'Kostenvoranschlags-Nr.',
        labelPoNo: 'Bestell-Nr.',
        labelCreditMemoNo: 'Gutschrift-Nr.',
        labelDueDate: 'Fälligkeitsdatum',
        labelTerms: 'Zahlungsbedingungen',
        labelAmount: 'Betrag',
        labelCode: 'Code',
        labelDescription: 'Beschreibung',
        labelQuantity: 'Menge',
        labelRate: 'Satz',
        labelTax: 'Steuer',
        labelSubtotal: 'Zwischensumme',
        labelBalanceDue: 'Offener Betrag',
        labelDiscount: 'Rabatt',
        labelNonTaxableItem: 'Nicht steuerpflichtiger Artikel',
        labelPaid: 'Bezahlt',
        labelShipping: 'Versand',
        labelTotal: 'Gesamt',
        labelIncludes: 'Enthält',
        labelTotalAmountPaid: 'Gesamt bezahlter Betrag',
        labelShipDate: 'Versanddatum',
        labelShipTo: 'Liefern an',
        labelShipVia: 'Versand über',
        labelTrackingNo: 'Sendungsverfolgungs-Nr.',
        labelFob: 'F.O.B',
        prefix: 'Präfix',
        prefixInvoice: 'Rechnung',
        prefixEstimate: 'Kostenvoranschlag',
        prefixPurchaseOrder: 'Bestellung',
        prefixCreditMemo: 'Gutschrift',
        nextNumber: 'Nächste Nummer',
        numberingBeginsAt: 'Nummerierung beginnt bei',
        nextNumberInvoice: 'Rechnung',
        nextNumberEstimate: 'Kostenvoranschlag',
        nextNumberPurchaseOrder: 'Bestellung',
        nextNumberCreditMemo: 'Gutschrift',
        options: 'Optionen',
        optionTerms: 'Zahlungsbedingungen',
        optionDueDate: 'Fälligkeitsdatum',
        optionShippingAddress: 'Lieferadresse',
        optionProductCode: 'Produktcode',
        optionQuantityAndRate: 'Menge und Satz',
        optionTax: 'Steuer',
        optionAmount: 'Betrag',
        optionNonTaxableItemStar: 'Stern für nicht steuerpflichtigen Artikel',
        optionTaxBreakdown: 'Steueraufschlüsselung',
        optionPaymentHistory: 'Zahlungsverlauf',
        optionStamp: 'Stempel',
        optionPageNumber: 'Seitenzahl',
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewShipName: 'Peter',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewThanksMessage: "Danke für Ihr Geschäft! Wir hoffen, Sie sind mit unserer Arbeit zufrieden. Bitte überweisen Sie die Zahlung innerhalb von 15 Tagen. Fragen? Kommentare? Kontaktieren Sie uns unter (111)111-1234 oder schreiben Sie uns an example@owner.com, wir beantworten gerne alle Fragen oder Anliegen.",
        previewSubtotal: 'Zwischensumme',
        previewVat: 'MwSt 17.00%',
        previewPayment1: 'Zahlung am Oct 1, 2019',
        previewPayment2: 'Zahlung am Oct 2, 2019'
    },
    feedback: {
        title: 'Feedback senden',
        invalidEmailNoticePrefix: 'Die E-Mail-Adresse Ihres Kontos ist ungültig, daher konnten wir Sie nicht kontaktieren. Bitte senden Sie Ihr Feedback von einer gültigen E-Mail-Adresse an',
        invalidEmailNoticeSuffix: 'Falls möglich, fügen Sie einen Screenshot des Problems bei; das wird uns bei der Untersuchung und Lösung helfen.',
        replyTip: 'Überprüfen Sie nach dem Senden Ihre E-Mail auf die Antwort.',
        content: 'Inhalt',
        enterDescription: 'Beschreibung eingeben'
    },
    createExpense: {
        title: 'Ausgabe hinzufügen',
        description: 'Beschreibung',
        expenseDescriptionPlaceholder: 'Ausgabenbeschreibung',
        total: 'Gesamt',
        tax: 'Steuer',
        tip: 'Trinkgeld',
        expenseDate: 'Ausgabedatum',
        merchant: 'Händler',
        merchantPlaceholder: 'Händlernamen eingeben',
        categoryPlaceholder: 'Kategorie auswählen',
        addNewCategory: 'Neue Kategorie hinzufügen',
        deletePhoto: 'Löschen',
        addPhoto: 'Foto hinzufügen',
        deleteCategory: 'löschen',
        addCategory: 'Kategorie hinzufügen'
    },
    updateExpense: {
        title: 'Ausgabe aktualisieren',
        deleteExpense: 'Ausgabe löschen',
        confirmDeleteMsg: 'Dadurch wird die Ausgabe gelöscht. Fortfahren?'
    },
    notFound: {
        oops: 'HOPPLA!',
        notFoundMsg: "Wir können die gesuchte Seite leider nicht finden.",
        takeMeHome: 'Zurück zur Startseite'
    },
    classicPDF: {
        previewName: 'Robin',
        previewAddress: '726 Building St. #872',
        previewCity: 'Seattle,Washington',
        previewZip: '99999 US',
        previewDate: 'Oct 1,2019',
        previewDueDate: 'Nov 15,2019',
        previewShipName: 'Peter',
        previewFreeShipping: 'Kostenloser Versand',
        previewShipDate: 'Oct 2,2019',
        previewShipVia: 'Federal Express',
        previewItem1: 'Computer',
        previewItem2: 'Telefon',
        previewItem3: 'Geburtstagskuchen',
        previewTaxRate: '17%',
        nonTaxableNote: '* Kennzeichnet nicht steuerpflichtigen Artikel',
        thanksMessage: "Danke für Ihr Geschäft! Wir hoffen, Sie sind mit unserer Arbeit zufrieden. Bitte überweisen Sie die Zahlung innerhalb von 15 Tagen. Fragen? Kommentare? Kontaktieren Sie uns unter (111)111-1234 oder schreiben Sie uns an example@owner.com, wir beantworten gerne alle Fragen oder Anliegen.",
        subtotal: 'Zwischensumme',
        vat: 'MwSt 17.00%',
        payment1: 'Zahlung am Oct 1, 2019',
        payment2: 'Zahlung am Oct 2, 2019',
        balanceDue: 'Offener Betrag'
    }
};
